import React, { JSX } from "react";
import { Box, BoxProps, IconButton, IconButtonProps } from "@mui/material";
import DotsIcon from "@icons/myicons/dots.svg?react";
import { ActionsMenu } from "@components/common";

type Props = {
  children: JSX.Element;
  testId?: string;
  /**
   * Page headers pass "tertiary" to match the menu button PrimaryActionWithMenu
   * renders; table rows keep the plain default.
   */
  buttonColor?: IconButtonProps["color"];
} & BoxProps;

export const ButtonWithActionMenu = ({
  children,
  testId,
  buttonColor,
  ...rest
}: Props) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const handleOpenMenu = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  return (
    <Box display="flex" justifyContent="flex-end" alignItems="center" {...rest}>
      <IconButton
        data-testid={testId || "open-menu-button"}
        className="rangeSelectorButton"
        aria-controls="simple-menu"
        aria-haspopup="true"
        onClick={handleOpenMenu}
        color={buttonColor}
        size="small"
      >
        <DotsIcon />
      </IconButton>
      <ActionsMenu anchorEl={anchorEl} setAnchorEl={setAnchorEl}>
        {React.cloneElement(children, {
          handleCloseMenu,
        })}
      </ActionsMenu>
    </Box>
  );
};
